import React, { useState } from "react";
import {
  Modal as AntModal,
  Button,
  Form as AntForm,
  Input,
  Space,
  message,
} from "antd";
import styled from "styled-components";
import { CheckOutlined } from "@ant-design/icons";
import api from "../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 24px;
  }

  .ant-modal-header {
    padding: 24px;
    margin: 0;
    background: ${(props) => props.theme.backgroundColor};
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
  }

  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
  }

  .ant-modal-body {
    padding: 24px;
    text-align: center;
  }
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #1d1014;
  padding-bottom: 24px;
`;

const Form = styled(AntForm)`
  .ant-form-item:last-child {
    margin: 0;
  }

  .ant-space {
    width: 100%;

    .ant-space-item {
      flex: 1;
    }

    .ant-btn {
      width: 100%;
      height: 56px;
    }
  }
`;

const ForgotPasswordModal = ({ open, handleClose, successCallback, admin }) => {
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation();

  const getForgetPwd = () => {
    api
      .getForgetPwd()
      .then((res) => {
        successCallback();
        console.log(res);
      })
      .catch((err) => message.err(err));
  };
  const onFinish = () => {
    getForgetPwd();
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  return (
    <Modal
      centered
      closable={false}
      footer={false}
      width={576}
      open={open}
      onCancel={handleClose}
      title={`${t('forgot_pass')}?`}
    >
      <Text>
        {t('forgot_pass_text')}
      </Text>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item name={"email"} initialValue={admin?.email}>
          <Input placeholder={t('email')} readOnly />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="default" onClick={onCancel}>
              {t('cancel')}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<CheckOutlined />}
              loading={loading}
            >
              {t('submit')}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ForgotPasswordModal;
